// extracted by mini-css-extract-plugin
module.exports = {"component":"WhereToBuy_component__11Ew7","uniswap":"WhereToBuy_uniswap__dHZ3W"};